import {useHierarchy} from '@domain/kpis'
import {SxProps, Theme} from '@mui/material'
import {useParams} from 'react-router'

import {LocationBreadcrumbs as SharedLocationBreadcrumbs} from '../../shared/components'

type PathParameter = {
  areaId?: string
}

type Props = {
  sx?: SxProps<Theme>
}

export const LocationBreadcrumbs = ({sx}: Props) => {
  const {areaId} = useParams<PathParameter>()
  const {data: hierarchy} = useHierarchy({enabled: !!areaId})

  return <SharedLocationBreadcrumbs sx={sx} hierarchy={hierarchy} />
}
